


import React, { useEffect, useState } from "react";
import { navigateWithFai } from "../utils/Utils";
import { lifestyleApi } from "../apiService/api";
import { getUrlParams } from "../apiService/timespam";
import { useTranslation } from "react-i18next";


export default function GoqiiCare() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    const { encryptedId } = getUrlParams();
    if (!encryptedId) return;

    lifestyleApi
      .goqiiData(encryptedId)
      .then((response) => {
        if (response?.data?.code === 200) {
          setData(response.data.data);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  if (!data) {
    return (
      <div style={{
        textAlign: "center",
        marginTop: 40,
        fontSize: 14,
        fontFamily: "Open Sans",
        color: "#4d4d4d"
      }}>
        {t("goqiiCare.loading")}
      </div>
    );
  }


  const list = [
    data.coachName && {
      role: t("goqiiCare.roles.coach"),
      name: data.coachName,
      img: data.coachImage,
      link: data.coachLink
    },
    data.expertName && {
      role: t("goqiiCare.roles.expert"),
      name: data.expertName,
      img: data.expertImage,
      link: data.expertLink
    },
    data.doctorName && {
      role: t("goqiiCare.roles.doctor"),
      name: data.doctorName,
      img: data.doctorImage,
      link: data.doctorLink
    }
  ].filter(Boolean).slice(0, 3);

  return (
    <div
      style={{
        width: "100%",
        padding: 5,
        borderRadius: 20,
        background: "var(--bg-card)",
        border: "1px solid var(--border-subtle)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
        textAlign: "center",
      }}
    >

      <h2
        style={{
          fontSize: 20,
          fontWeight: 700,
          color: "var(--text-primary)",
          marginBottom: 15,
        }}
      >
        {data.HudTitle || t("goqiiCare.title")}
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: list.length === 1 ? "center" : "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        {list.map((m, i) => (
          <div key={i} style={{ textAlign: "center", flex: 1 }}>


            <div
              style={{
                border: "1px solid #fff",
                width: window.innerWidth < 420 ? 70 : 84,
                height: window.innerWidth < 420 ? 70 : 84,
                borderRadius: "50%",
                background: "#fff",
                justifyContent: "center",
                alignItems: "center",

                overflow: "hidden",
                margin: "0 auto 8px auto",
                cursor: "pointer",
              }}
              onClick={() => {


                window.location.href = m.link;
              }}
            >
              {/* Image that fits perfectly in circle */}
              <img
                src={m.img}
                alt={m.role}
                style={{
                  width: "100%",
                  height: "100%",
                  display: "block",
                  borderRadius: 0,
                  objectFit: "cover",
                }}
              />
            </div>

            <div
              style={{
                fontSize: window.innerWidth < 420 ? 12 : 15,
                fontWeight: 700,
                color: "var(--text-primary)",
                whiteSpace: "nowrap"
              }}
            >
              {m.role}
            </div>

            <div
              style={{
                fontSize: window.innerWidth < 420 ? 11 : 14,
                fontWeight: 500,
                color: "var(--text-secondary)",
                whiteSpace: "nowrap"
              }}
            >
              {m.name}
            </div>
          </div>
        ))}
      </div>

      {/* Body text */}
      {data.showBody && (
        <div style={{ marginTop: 12, fontSize: 9, color: "#4d4d4d", textAlign: "left" }}>
          {data.healthtext}
        </div>
      )}
    </div>
  );
}








